<template>
  <div class="productDetails">
    <div class="boxCenter">
      <div class="productIntroduce">
        <div class="imgBox">
          <div class="bigImgBox"><img :src="curShowImg" alt="TINDOE坦途"/></div>
          <div class="imgItems">
            <div class="item" v-for="(item,index) in imgList" :key="index" @click="curShowImgSwitch(item)"><img :src="item.pic" alt="TINDOE坦途"/></div>
          </div>
          <div class="signNum"><span class="spanBlod">{{dataObj.signUp}} 人</span>已报名  &nbsp;&nbsp;&nbsp; <span class="phonePurchase">手机购买</span></div>
        </div>
        <div class="infoBox">
          <div class="title"><span>{{dataObj.themName}}</span> {{dataObj.name}}</div>
          <div class="slogan">{{dataObj.intro}}</div>
          <div class="notices"> 出团通知： 最少参与人数{{dataObj.signMinimum}}人 &nbsp;&nbsp;  最多参与人数{{dataObj.signMost}}人 &nbsp;&nbsp;  编号：{{dataObj.code}}</div>
          <div class="setMeal">
            <div class="times">周期 {{dataObj.cycle}}</div>
            <div class="priceBox">会员价格 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <template v-if="dataObj.checkPrice == 1 && dataObj.price > 0">
                  <span style="color:#e40000;font-size: 18px;margin-right: 4px;">¥</span><span style="color:#e40000;font-size:32px;">{{dataObj.price.toFixed(2)}}</span>&nbsp; 元（成人）
              </template>
              <template v-if="dataObj.checkChildPrice == 1 && dataObj.childPrice > 0">
                  <span style="color:#e40000;font-size: 18px;margin-right: 4px;">&nbsp;&nbsp;&nbsp;¥</span><span style="color:#e40000;font-size:32px;">{{dataObj.childPrice.toFixed(2)}}</span> 元（儿童）
              </template>
            </div>
            <div class="characteristic">产品特色&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{dataObj.themName}}</span> <span>{{dataObj.typeName}}</span></div>
          </div>
          <div class="propertyShows">
            <div class="item" v-for="(item,index) in propertyShows" :key="index">
              <div class="itemTh">{{item.propertyName}}</div>
              <div class="itemTd">
                <span v-for="(row,k) in item.propertyVelues" :class="row.selected ? 'active' : ''" :key="k" @click="selectProper(item.propertyVelues,k)">{{row.valueInfo}}</span>
              </div>
            </div>
          </div>
          <div class="propertyShows">
            <div class="item">
              <div class="itemTh">{{dataObj.classify == 1 ? '活动场地' : ' 目 的 地'}}</div>
              <div class="itemTd" style="font-size: 14px;">{{dataObj.destination}}</div>
            </div>
          </div>
          <div class="propertyShows">
            <div class="item">
              <div class="itemTh">{{dataObj.classify == 1 ? '活动课时' : ' 出 发 地'}}</div>
              <div class="itemTd" style="font-size: 14px;">{{dataObj.startLocation}}</div>
            </div>
          </div>
          <!-- <div class="address">{{dataObj.classify == 1 ? '活动场地' : ' 目 的 地'}}：&nbsp;&nbsp;<span style="color: #fe5a43">{{dataObj.destination}}</span>
          </div> -->
          <div class="address" style="display:block"><div class="payStyle">支付方式 <span class="wx">微信</span></div>
          </div>
          <!-- <div class="el-icon-timer" style="padding:0 150px 0 30px;line-height:21px;"> 出行时间：
            <span style="color:#999" v-for="(item,index) in dataObj.travelDates" :key="index">{{item}}; </span>
          </div> -->
          <div class="totalPrice">
            <div class="num" v-show="false">
              数量：&nbsp;&nbsp;&nbsp; <el-input-number v-model="num" size="mini" :min="1" :max="10" label="描述文字"></el-input-number>
            </div>
            <div class="tp">
              <!-- <span v-if="!signUpFlag" class="buyBtn" style="background: #999;cursor:not-allowed ">立即报名</span> -->
              <span class="buyBtn" @click="makeOrder" >立即报名</span>
            </div>
          </div>
        </div>
      </div>
      <div class="travelDateBox">
        <div class="travelDateBoxM">
          <span class="spanTitle">{{dataObj.classify == 1 ? '活动开始时间' : '出行时间'}}：</span>
          <span class="spanItem" v-for="(item,index) in dataObj.travelDates" :key="index">{{item}}</span>
        </div>
      </div>
      <div class="proInfoBox">
        <div class="tabTh">
          <div class="tabThItem"><a @click.prevent="custormAnchor('explain1')">{{dataObj.classify == 1 ? '课程特色' : '图文详情'}}</a></div>
          <div class="tabThItem"><a @click.prevent="custormAnchor('explain2')">{{dataObj.classify == 1 ? '课程安排' : '行程计划'}}</a></div>
          <div class="tabThItem"><a @click.prevent="custormAnchor('explain3')">费用说明</a></div>
          <div class="tabThItem"><a @click.prevent="custormAnchor('explain4')">报名须知</a></div>
          <div class="tabThItem"><a @click.prevent="custormAnchor('explain5')">活动评价</a></div>
        </div>
        <div class="tabTd">
          <div class="tabTdItem">
            <div style="position: relative;top: -90px;height: 1px;width: 100%;" id="explain1"></div>
            <div class="title">{{dataObj.classify == 1 ? '课程特色' : '图文详情'}}</div>
            <div class="content" v-html="dataObj.explain1"></div>
            <div style="position: relative;top: -90px;height: 1px;width: 100%;" id="explain2"></div>
            <div class="title">{{dataObj.classify == 1 ? '课程安排' : '行程计划'}}</div>
            <div class="content" v-html="dataObj.explain2"></div>
            <div style="position: relative;top: -90px;height: 1px;width: 100%;" id="explain3"></div>
            <div class="title">费用说明</div>
            <div class="content" v-html="dataObj.explain3"></div>
            <div style="position: relative;top: -90px;height: 1px;width: 100%;" id="explain4"></div>
            <div class="title">报名须知</div>
            <div class="content" v-html="dataObj.explain4"></div>
            <div style="position: relative;top: -90px;height: 1px;width: 100%;" id="explain5"></div>
            <div class="title">活动评价</div>
            <div class="content">
              <div class="rateBox" v-for="(item,index) in rateList" :key="index">
                <div><el-rate v-model="item.star" :disabled="true"></el-rate></div>
                <div class="Rcontent">{{item.desc}}</div>
                <div class="author">{{item.nickname}} {{item.createDate?item.createDate.substring(0,19):''}}</div>
                <el-divider></el-divider>
              </div>
              <div style="padding:10px;text-align: center">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  @current-change="handleCurrentChange"
                  :current-page="curPage"
                  :page-size="10"
                  :total="totalRate">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="newProductList" v-if="dataObj.goodsModels && dataObj.goodsModels.length > 0">
        <div class="title">商品推荐</div>
        <ul>
          <li v-for="(item,index) in dataObj.goodsModels" :key="index">
            <router-link :to="'/productDetails/'+item.id">
            <img :src="item.pic" alt="TINDOE坦途"/>
            <p class="price"><span>¥</span>{{item.price.toFixed(2)}}</p>
            </router-link>
          </li>
        </ul>
      </div>
      <!-- <el-dialog width="460px" title="请用微信扫描下方小程序码报名" :visible.sync="dialogTableVisible">
        <div style="text-align:center;"><img :src="shareCode" alt="TINDOE坦途"/></div>
      </el-dialog> -->
    </div>
  </div>
</template>

<script>
  import eventVue from '../bus.js'
  export default {
    data(){
      return {
        //dialogTableVisible:false,
        num:'1',
        tabType:1,
        activityId:'',
        dataObj:{},
        imgList:[],
        curShowImg:'',
        rateList:[],
        explain1Arr:[],
        explain2Arr:[],
        explain3Arr:[],
        explain4Arr:[],
        //shareCode:'',
        propertyShows:[],
        propertyArr:[],//选中的属性
        signUpFlag:false,
        totalRate:0,
        curPage:1
      }
    },
    computed: {
      userData() {
        return this.$store.state.userData
      }
    },
    mounted(){
      this.activityId = this.$route.params.id
      //this.shareCode = 'http://www.tindoe.com/apiserver/api/deCode/id/' + this.activityId
      this.loadInforData()
      this.loadRateList()
    },
    methods:{
      handleCurrentChange(val){
        this.curPage = val
        this.loadRateList()
      },
      //图片点击切换显示
      curShowImgSwitch(item){
        this.curShowImg = item.pic
      },
      // contentInfoChange(type){
      //   this.tabType = type
      // },
      loadInforData(){
        this.$https.get('/api/travel/id/'+this.activityId).then((response)=>{
          if (response.data.propertyShows) {
            let datarow = response.data.propertyShows
            datarow.forEach(item => {
              //默认不选中
              item.propertyVelues.forEach(row => {
                row.selected = false
              })
              //如果单个的话就选中
              if(item.propertyVelues.length == 1){
                item.propertyVelues[0].selected = true
              }

            })
            this.propertyShows = datarow
            //渲染之后
            this.$nextTick(()=>{
              this.propertySelectedAll()
            })
          }
          this.imgList = response.data.travelPics.slice(0, 5)
          //富文本内容 如果没有标签
          var pattern = /<("[^"]*"|'[^']*'|[^'">])*(>|$)|\s+/g;
          if (response.data.explain1 && response.data.explain1.split(',').length > 0 && !pattern.test(response.data.explain1)) {
              var html = "<p>"
              response.data.explain1.split(',').forEach(url => {
                html += "<img src='"+url+"' alt=''  data-href='' style='width:100%; display:block; margin:10px auto; height:auto;' />"
              })
              html += "</p>"
              response.data.explain1 = html
          }
          if (response.data.explain2 && response.data.explain2.split(',').length > 0 && !pattern.test(response.data.explain2)) {
              var html = "<p>"
              response.data.explain2.split(',').forEach(url => {
                html += "<img src='"+url+"' alt=''  data-href='' style='width:100%; display:block; margin:10px auto; height:auto;' />"
              })
              html += "</p>"
              response.data.explain2 = html
          }
          if (response.data.explain3 && response.data.explain3.split(',').length > 0 && !pattern.test(response.data.explain3)) {
              var html = "<p>"
              response.data.explain3.split(',').forEach(url => {
                html += "<img src='"+url+"' alt=''  data-href='' style='width:100%; display:block; margin:10px auto; height:auto;' />"
              })
              html += "</p>"
              response.data.explain3 = html
          }
          if (response.data.explain4 && response.data.explain4.split(',').length > 0 && !pattern.test(response.data.explain4)) {
              var html = "<p>"
              response.data.explain4.split(',').forEach(url => {
                html += "<img src='"+url+"' alt=''  data-href='' style='width:100%; display:block; margin:10px auto; height:auto;' />"
              })
              html += "</p>"
              response.data.explain4 = html
          }
         
          this.curShowImg = response.data.pic
          this.dataObj = response.data
        }).catch((error) => {});
      },
      custormAnchor(index) { //锚点滚动到固定位置      
         let anchorElement = document.getElementById(index);
         if(anchorElement) { anchorElement.scrollIntoView(); }               
      },
      loadRateList(){
        this.$https.get('/api/travelEvaluation/pageIndex/'+this.curPage+'/pageNum/10?travelId='+this.activityId).then((response)=>{
          this.rateList = response.data.records
          this.totalRate = response.data.total
        }).catch((error) => {});
      },
      makeOrder(){
        if(!this.userData){
          eventVue.$emit("callLogin")
          return
        }
        let proStr = []
        this.propertyArr.forEach(item => {
          proStr.push(item.valueInfo)
        })
        if(this.propertyShows.length>0 && proStr.length == 0){
          this.$message.warning('请先选择套餐')
          return
        }
        this.$router.push({
          path:'/activeOrderConfirm',
          query: {
            id:this.activityId,
            propertyArr:proStr.join(','),
            price:this.dataObj.price,
            childPrice:this.dataObj.childPrice
          }
        })
      },
      selectProper(list,index){
        list.forEach(item => {
          item.selected = false
        })
        list[index].selected = true
        this.$forceUpdate();
        this.propertySelectedAll()
      },
      propertySelectedAll:function(){
        let result = true
        let pIdArr = []
        let propertyArr = []
        let list = this.propertyShows
        for (var i = 0; i < list.length; i++) {
          let flag = false
          let row = list[i].propertyVelues
          for (var j = 0; j < row.length; j++) {
            if(row[j].selected){
              flag = true
              pIdArr.push(row[j].relevanceId)
              let tempObj = {}
              tempObj.name = list[i].propertyName
              tempObj.relevanceId = row[j].relevanceId
              tempObj.valueInfo = row[j].valueInfo
              propertyArr.push(tempObj)
              continue
            }
          }
          if (!flag) {
            result = false
            break
          }
        }
        if(result){
          this.propertyArr = propertyArr
          this.getPriceByProper(pIdArr.join(','))
        }
        this.signUpFlag = result
      },
      //根据属性查询商品最新价格
      getPriceByProper(pIds){
        this.$https.get('/api/travel/id/'+this.activityId+'/relevanceIds/'+pIds).then((response)=>{
          if(this.dataObj.price > 0){
            this.dataObj.price = response.data.price
          }
          if(this.dataObj.childPrice > 0){
            this.dataObj.childPrice = response.data.childPrice
          }
        }).catch((error) => {});
      },
    }
  }
</script>

<style scoped>
  .propertyShows{
    padding: 0 30px;
  }
  .propertyShows .item{
    line-height: 40px;
    margin-top: 15px;
  }
  .propertyShows .itemTh{
    float: left;
    width: 100px;
    height: 40px;
    overflow: hidden;
    font-size: 13px;
    color: #363636;
  }
  .propertyShows .itemTd{
    padding-left: 100px;
  }
  .propertyShows .itemTd span{
    display: inline-block;
    height: 28px;
    line-height: 28px;
    padding: 0 13px;
    border: 1px solid #cdcdcd;
    font-size: 13px;
    color: #363636;
    cursor: pointer;
    position: relative;
    margin-top:5px;
    margin-bottom: 5px; 
    margin-right: 7px;
  }
  .propertyShows .itemTd span.active{
    border: 1px solid #ffcd30;
    background: url("../assets/images/properSelected.png") no-repeat right bottom;
  }

  .rateBox .Rcontent{
    padding:10px 0;
    color:#666666
  }
  .rateBox .author{
    color:#333333;
    font-size:12px;
  }
  .productIntroduce{
    padding-top: 15px;
    overflow: hidden;
  }
  .imgBox{
    float: left;
    width: 503px;
  }
  .imgBox .bigImgBox{
    width: 503px;
    height: 267px;
  }
  .imgBox img{
    width: 100%;
    height: 100%;
  }
  .imgBox .imgItems{
    overflow: hidden;
    padding-top: 4px;
  }
  .imgBox .imgItems .item{
    float: left;
    width: 95px;
    height: 50px;
  }
  .imgBox .imgItems .item+.item{
    margin-left: 7px;
  }
  .imgBox .signNum{
    line-height: 47px;
    font-size: 13px;
    color: #363636;
  }
  .imgBox .signNum .spanBlod{
    font-weight: bold;
  }
  .imgBox .signNum .spanRed{
    color: #fe5a43;
  }
  .imgBox .signNum .collection{
    padding-left: 21px;
    background: url("../assets/images/aixin.png") no-repeat left center;
  }
  .imgBox .signNum .phonePurchase{
    padding-left: 14px;
    background: url("../assets/images/shouji.png") no-repeat left center;
  }
  .infoBox{
    float: left;
    width: 697px;
  }
  .infoBox .title{
    padding-left: 25px;
    padding-top: 2px;
    max-height: 90px;
    line-height: 30px;
    font-size: 20px;
    overflow: hidden;
  }
  .infoBox .title span{
    font-weight: normal;
    line-height: 28px;
    padding: 5px 10px;
    background: #ffcd30;
    color: #ffffff;
    font-size: 14px;
    border-radius: 3px;
  }
  .infoBox .slogan{
    line-height: 21px;
    font-size: 15px;
    color: #5680f9;
    padding-left: 25px;
  }
  .infoBox .setMeal{
    height: 153px;
    margin-left: 30px;
    padding-right: 10px;
    background: #f4f7ff;
    position: relative;
    padding-left: 5px;
  }
  .infoBox .setMeal .times{
    position: absolute;
    right: 0px;
    top: 12px;
    height: 26px;
    line-height: 26px;
    padding: 0 10px;
    background: #ffcd30;
    border-top-left-radius: 9px;
    color: #ffffff;
    font-size: 13px;
  }
  .infoBox .setMeal .priceBox{
    padding-top: 18px;
    height: 64px;
    line-height: 64px;
    border-bottom: 1px solid #7698fa;
    font-size: 13px;
    color: #363636;
  }
  .infoBox .setMeal .characteristic{
    height: 68px;
    line-height: 68px;
    font-size: 13px;
    color: #363636;
  }
  .infoBox .setMeal .characteristic span{
    display: inline-block;
    height: 18px;
    line-height: 18px;
    padding: 0 3px;
    border: 1px solid #7698fa;
    color: #5680f9;
  }
  .infoBox .notices{
    height: 29px;
    line-height: 29px;
    padding-left: 30px;
    font-size: 13px;
    color: #363636;
    margin-top: 7px;
  }
  .infoBox .address{
    height: 36px;
    line-height: 50px;
    padding-left: 30px;
  }
  .infoBox .address .payStyle{
    float: right;
    padding-right: 18px;
  }
  .infoBox .address .payStyle .zfb{
     padding-left: 20px;
     background: url("../assets/images/zhifubao.png") no-repeat left center;
    margin-left: 13px;
   }
  .infoBox .address .payStyle .xyk{
    padding-left: 20px;
    background: url("../assets/images/xinyonka.png") no-repeat left center;
    margin-left: 13px;
  }
  .infoBox .address .payStyle .wx{
    padding-left: 20px;
    background: url("../assets/images/wxicon.png") no-repeat left center;
    margin-left: 13px;
  }
  .infoBox .totalPrice{
    clear:both;
    height: 55px;
    line-height: 55px;
    font-size: 13px;
    color: #363636;
  }
  .infoBox .totalPrice .num{
    float: left;
    padding-left: 30px;
  }
  .infoBox .totalPrice .tp{
    float: right;
  }
  .infoBox .totalPrice .tp .buyBtn{
    display: inline-block;
    width: 124px;
    height: 38px;
    border-radius: 3px;
    background: #ffcd30;
    line-height: 38px;
    text-align: center;
    margin-right: 7px;
    color: #ffffff;
    font-size: 18px;
    cursor: pointer;
  }
  .proInfoBox{
    padding: 0 0 22px;
  }
  .proInfoBox .tabTh{
    border:1px solid #5680f9;
    border-top:2px solid #5680f9;
    height: 32px;
    background: #f4f7ff;
  }
  .proInfoBox .tabTh .tabThItem{
    float: left;
    height: 21px;
    line-height: 21px;
    padding: 0 15px;
    border-radius: 21px;
    font-size: 15px;
    color: #363636;
    margin: 5px 0 0 30px;
    cursor: pointer;
  }
  .proInfoBox .tabTh .tabThItem.active{
    color: #ffffff;
    background: #5680f9;
  }
  .proInfoBox .tabTd{
    margin-top:11px;
  }
  .proInfoBox .tabTdItem{
    background: #f6f5f5;
    border:1px solid #cdcdcd;
    padding:0 30px;
  }
  .proInfoBox .tabTdItem .title{
    height: 44px;
    line-height: 44px;
    border-bottom:2px solid #5680f9;
    padding: 0 20px;
    font-size: 15px;
    color: #363636;
  }

  .proInfoBox .tabTdItem .content{
    background: #fff;
    padding: 30px;
    line-height: 25px; 
    word-break: break-all; word-wrap: break-word;
  }
  .proInfoBox .tabTdItem .content *{
    word-break: break-all; word-wrap: break-word;
  }
  .contentTable{
    width: 100%;
  }
  .contentTable td{
    line-height: 40px;
    font-size: 13px;
    color: #363636;
  }
  .newProductList{
  }
  .newProductList .title{
    height: 46px;
    line-height: 46px;
    padding: 0 35px;
    background: #5680f9;
    color: #ffffff;
    font-size: 17px;
  }
  .newProductList ul{
    padding-top: 12px;
    width: 1233px;
    margin-left: -33px;
    overflow: hidden;
  }
  .newProductList ul li{
    width: 378px;
    height: 301px;
    float: left;
    margin: 0 0 33px 33px;
    background: #ffffff;
    position: relative;
    box-shadow:0px 2px 4px 0px rgba(0,0,0,0.05);
  }
  .newProductList ul li img{
    width: 100%;
    height: 100%;
  }
  .newProductList .price{
    width: 308px;
    height: 56px;
    line-height: 56px;
    padding: 0 35px;
    position: absolute;
    bottom: 0px;
    left: 0px;
    font-size: 32px;
    color: #ffcd30;
  }
  .newProductList .price span{
    font-size: 18px;
    margin-right: 4px;
  }
  .travelDateBox{
    background:#f8f8f8;
    padding:12px 30px;
  }
  .travelDateBoxM{
    position:relative
  }
  .travelDateBoxM .spanTitle{
  }
  .travelDateBoxM .spanItem{
    display:inline-block;
    padding:0px 10px;
    background:#5680f9;
    height:25px;
    line-height:25px;
    border-radius:25px;
    color:#ffffff;
    margin:5px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/activitieDetails.vue